





















































































































































































































































































































































































































































































































































// Vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader, Loading } from '@/components'
import { Input, Radio, TextArea, Select, DatePicker } from '@/components/form'
import {
    TableConcubine,
    TableChildren,
    AssignmentSectionForm,
    FinancesSectionForm,
    InsuranceSectionForm,
    PlameSectionForm
} from '@/components/config'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, email, numeric, requiredIf, minValue, maxValue } from 'vuelidate/lib/validators'

// Models
import { PropOptionSelect } from '@/models'
import { EmployeeModel, StateModel, ChildModel } from '@/models/config'

// services
import { StateService, EmployeeService } from '@/services/config'

// constants
import { optionsConcubineTypes, documentTypes, optionsSex } from '@/constants'

// utils
import { alerts, loading, dateLibs } from '@/utils'

@Component({
    name: 'CreateEditEmployeeView',
    components: {
        PageHeader,
        Input,
        Radio,
        TextArea,
        Select,
        DatePicker,
        TableConcubine,
        TableChildren,
        AssignmentSectionForm,
        FinancesSectionForm,
        InsuranceSectionForm,
        Loading,
        PlameSectionForm
    },
    mixins: [validationMixin]
})
export default class CreateEditEmployeeView extends Vue {
    title = 'Empleados'
    showCollapseChildren = true
    actionForm: 'save'|'update' = 'save'
    employeeUpdateID!: number
    location: StateModel[]|[] = []
    loading = false
    codeOld: string|null = null
    initConcubine = {
        name: '',
        last_name: '',
        document_type: 0,
        document_number: '',
        phone_number: '',
        date_birth: dateLibs.today()
    }

    itemChild: ChildModel = {
        name: '',
        last_name: '',
        date_birth: dateLibs.today(),
        document_type: '',
        document_number: ''
    }

    employee: EmployeeModel = {
        uid: 0,
        email: '',
        name: '',
        last_name: '',
        mothers_last_name: '',
        sex: null,
        document_type: null,
        document_number: '',
        phone_number: '',
        phone_number_ref: '',
        current_address: '',
        ref_address: '',
        document_address: '',
        academic_level: '',
        titles_obtained: '',
        date_birth: dateLibs.today(),
        work_start_date: dateLibs.today(),
        trusted_person: false,
        state_id: null,
        city_id: null,
        district_id: null,
        concubine_type: 0,
        has_children: false,
        is_active: true,
        concubine: this.initConcubine,
        devices: [],
        produccion: 0,
        adicional: 0,
        reintegro: 0,
        responsabilidad: 0,
        asistencia: 0,
        assignment: {
            cost_center_id: null,
            position_id: null,
            headquarter_id: null,
            area_id: null,
            sub_area_id: null,
            work_shift_id: null,
            work_category: null,
            work_type: null,
            type_of_contract: 4,
            condition: 1,
            lunch: false,
            lunch_rate_id: null,
            labor_regime: 1,
            contrato_number: '',
            fixed_dialing: false
        },
        finance: {
            bank: '',
            telecredito: null,
            tipo_cuenta: null,
            moneda: null,
            account_number: '',
            family_allowance: null,
            regular_bonus: null,
            base_salary: null,
            payment_frequency: 'biweekly',
            regular_amount: null,
            ordinary_perks: null,
            bank_cts: '',
            account_number_cts: ''
        },
        insurance: {
            afp_id: null,
            life_insurance: false,
            insurance_company_id: null,
            rent: false,
            right_environment: false,
            agricultural_insurance: false,
            regular_insurance: false,
            sctr_life: false,
            eps: false,
            type_regime: 1,
            cussp: '',
            sctr_pension: false,
            sctr_pension_description: null,
            date_afp: null,
            type_of_commission: null,
            gratification: false,
            sctr_health: false
        },
        children: [],
         bono: [],
         tiposbono: [],
        plame: {
            ensures_pension: false,
            essalud: false,
            domiciled: false
        }
    }

    items = [
        {
            text: 'Dashboard'
        },
        {
            text: 'Empleados',
            to: { name: 'employees' }
        },
        {
            text: 'Formulario de Empleado',
            active: true
        }
    ]

    documentTypes = documentTypes
    optionsConcubineTypes = optionsConcubineTypes

    mounted () {
        this.getLocation()
        if (this.$route.name === 'employees-form-edit') {
            this.employeeUpdateID = Number(this.$route.params.id)
            this.getEmployee(this.employeeUpdateID)
        } else {
            this.getNextCode()
        }
    }

    @Validations()
    validations () {
        const employee = this.employee
        const codeOld = this.codeOld
        return {
            employee: {
                uid: {
                    required,
                    numeric,
                    maxLength: maxLength(5),
                    minLength: minLength(1),
                    minValue: minValue(1),
                    maxValue: maxValue(65534),
                    isUnique: async (value: string) => {
                        if (String(value) === codeOld) return true
                        const result = EmployeeService.validateCode(value)
                        return (await result).success
                    }
                },
                email: { required, email },
                name: { required, minLength: minLength(2) },
                last_name: { required, minLength: minLength(2) },
                mothers_last_name: { required, minLength: minLength(2) },
                sex: { required },
                document_type: { required },
                document_number: { required },
                phone_number: { required },
                academic_level: { required },
                date_birth: { required },
                work_start_date: { required },
                trusted_person: { required },
                state_id: { required },
                city_id: { required },
                district_id: { required },
                concubine_type: { required },
                has_children: { required },
                is_active: { required },
                concubine: {
                    name: {
                        requiredIf: requiredIf(function (concubineV) {
                            return concubineV && concubineV.concubine_type > 0
                        })
                     },
                    last_name: {
                        requiredIf: requiredIf(function (concubineV) {
                            return concubineV && concubineV.concubine_type > 0
                        })
                     },
                    document_type: {
                        requiredIf: requiredIf(function (concubineV) {
                            return concubineV && concubineV.concubine_type > 0
                        })
                     },
                    document_number: {
                        requiredIf: requiredIf(function (concubineV) {
                            return concubineV && concubineV.concubine_type > 0
                        })
                     },
                    phone_number: {
                        requiredIf: requiredIf(function (concubineV) {
                            return concubineV && concubineV.concubine_type > 0
                        })
                     },
                    date_birth: {
                        requiredIf: requiredIf(function (concubineV) {
                            return concubineV && concubineV.concubine_type > 0
                        })
                     }
                },
                children: {
                    $each: {
                        name: { required },
                        last_name: { required },
                        document_type: { required },
                        document_number: { required },
                        date_birth: { required }
                    }
                },
                bono: {
                    $each: {
                        amount: { required }
                    }
                },
                assignment: {
                    cost_center_id: { required, numeric },
                    position_id: { required, numeric },
                    headquarter_id: { required, numeric },
                    area_id: { required, numeric },
                    sub_area_id: { required, numeric },
                    work_shift_id: { required, numeric },
                    work_category: { required, numeric },
                    condition: { required, numeric },
                    labor_regime: { required, numeric },
                    work_type: { required, numeric },
                    type_of_contract: { required, numeric },
                    lunch: { required }
                },
                finance: {
                    bank: { required },
                    telecredito: { required },
                    tipo_cuenta: { required },
                    moneda: { required },
                    account_number: { required },
                    family_allowance: { required },
                    base_salary: { required },
                    payment_frequency: { required },
                    ordinary_perks: { required },
                    bank_cts: { required },
                    account_number_cts: { required }
                },
                insurance: {
                    type_regime: { required },
                    insurance_company_id: {
                        requiredIf: requiredIf(function (validations) {
                            return validations.sctr_life
                        })
                    },
                    afp_id: {
                        requiredIf: requiredIf(function (validations) {
                            return validations.type_regime === 2
                        }),
                        numeric
                    },
                    cussp: {
                        requiredIf: requiredIf(function (validations) {
                            return validations.type_regime === 2
                        })
                    },
                    date_afp: {
                        requiredIf: requiredIf(function (validations) {
                            return validations.type_regime === 2
                        })
                    },
                    type_of_commission: {
                        requiredIf: requiredIf(function (validations) {
                            return validations.type_regime === 2
                        })
                    },
                    sctr_pension_description: {
                        requiredIf: requiredIf(function (validations) {
                            return validations.sctr_pension
                        })
                    }
                },
                devices: {
                    $each: {
                        name: {
                            requiredIf: requiredIf(() => {
                                return employee.devices && employee.devices.length > 0
                            })
                        },
                        password: {
                            numeric,
                            minLength: minLength(1),
                            maxLength: maxLength(8),
                            requiredIf: requiredIf(() => {
                                return employee.devices && employee.devices.length > 0
                            })
                        }
                    }
                }
            }
        }
    }

    async getNextCode () {
        this.loading = true
        const code = await EmployeeService.getNextCode()
        if (code && code > 0) {
            this.employee.uid = code
        }
        this.loading = false
    }

    async getEmployee (id: number) {
        this.loading = true
        const employee = await EmployeeService.getByID(id)
        this.employee = {
            ...employee
        }
        this.codeOld = String(this.employee.uid)
        delete this.employee.id
        // @ts-ignore
        delete this.employee.__typename
        // @ts-ignore
        delete this.employee.assignment?.__typename
        // @ts-ignore
        delete this.employee.concubine?.__typename
        // @ts-ignore
        delete this.employee.finance?.__typename
        // @ts-ignore
        delete this.employee.insurance?.__typename
        // @ts-ignore
        delete this.employee.children?.__typename
        // @ts-ignore
        delete this.employee.bono?.__typename
        // @ts-ignore
        delete this.employee.assignment.lunch_rate
        // @ts-ignore
        delete this.employee.assignment.cost_center
        // @ts-ignore
        delete this.employee.assignment.position
        // @ts-ignore
        delete this.employee.assignment.headquarter
        // @ts-ignore
        delete this.employee.assignment.area
        // @ts-ignore
        delete this.employee.assignment.sub_area
        // @ts-ignore
        delete this.employee.assignment.work_shift

        this.employee.children.forEach(child => {
            // @ts-ignore
            delete child?.__typename
        })
        this.loading = false
        this.actionForm = 'update'
        setTimeout(() => {
            if (this.employee.concubine_type > 0) {
                this.employee.concubine = {
                    ...employee.concubine
                }
                this.initConcubine = {
                    name: employee.concubine.name,
                    last_name: employee.concubine.last_name,
                    document_type: employee.concubine.document_type,
                    document_number: employee.concubine.document_number,
                    phone_number: employee.concubine.phone_number,
                    date_birth: String(employee.concubine.date_birth)
                }
            }
        }, 1000)
    }

    async getLocation () {
        const location = await StateService.getStateActive()
        this.location = location
    }

    addChild () {
        this.employee.children.push({
            ...this.itemChild
        })
    }

    setDevices (devicesSelected: { devices: number[]; password: string; name: string }) {
        if (devicesSelected.devices) {
            this.employee.devices = devicesSelected.devices.map(device => {
                return {
                    device_id: device,
                    password: devicesSelected.password,
                    name: devicesSelected.name
                }
            })
        }
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            this.employee.document_type = parseInt(String(this.employee.document_type))
            this.employee.concubine_type = parseInt(String(this.employee.concubine_type))
            if (this.employee?.concubine?.document_type) {
                this.employee.concubine.document_type = parseInt(String(this.employee.concubine.document_type))
            }
            try {
                this.employee.uid = parseInt(String(this.employee.uid))
                if (this.actionForm === 'save') {
                   const res = await EmployeeService.create(this.employee)
                   if (!res.response.success) {
                       loading('hide')
                       return alerts.error(res.response.msg)
                   }
                } else {
                    const res = await EmployeeService.update(this.employeeUpdateID, this.employee)
                    if (!res.response.success) {
                       loading('hide')
                       return alerts.error(res.response.msg)
                   }
                }
                alerts.success()
                this.$router.push({
                    name: 'employees'
                })
            } catch (e) {
                alerts.error('Ha ocurrido un error.!')
            }
            loading('hide')
        } else {
            alerts.error('Debe completar todos los campos requeridos (*) ')
        }
    }

    get states (): PropOptionSelect[] {
        const states: PropOptionSelect[] = []
        this.location.forEach(state => {
            if (state?.id) {
                states.push({
                    value: state.id,
                    text: state.name
                })
            }
        })
        return states
    }

    get cities (): PropOptionSelect[] {
        const cities: PropOptionSelect[] = []
        const state = this.location.find(state => state.id === this.employee.state_id)
        if (state) {
            const citiesInState = state.cities
            citiesInState.forEach(city => {
                if (city?.id) {
                    cities.push({
                        value: city.id,
                        text: city.name
                    })
                }
            })
        }
        return cities
    }

    get districts (): PropOptionSelect[] {
        const districts: PropOptionSelect[] = []
        const state = this.location.find(state => state.id === this.employee.state_id)
        if (state) {
            const citiesInState = state.cities
            const city = citiesInState.find(city => city.id === this.employee.city_id)

            if (city) {
                const districtInCity = city.districts
                districtInCity.forEach(district => {
                    if (district.id) {
                        districts.push({
                            value: district.id,
                            text: district.name
                        })
                    }
                })
            }
        }
        return districts
    }

    get titleForm (): string {
        if (this.$route.name === 'employees-form-edit') {
            return 'Editar Empleado: ' + this.employee.name + ' ' + this.employee.last_name
        }
        return 'Crear Nuevo Empleado'
    }

    get sexs (): PropOptionSelect[] {
        return optionsSex
    }
}
